import type { TokenExchangeResponse } from '@hetivo/hetivo-lib-types';
import axios from 'axios';

export interface TokenExchangeConfig {
  /** Base URL of the admin-auth API (e.g., http://localhost:3010) */
  exchangeUrl: string;
}

/** @deprecated Use TokenExchangeResponse from @hetivo/hetivo-lib-types directly */
export type TokenExchangeResult = TokenExchangeResponse;

/**
 * Exchange a Firebase ID token for a Hetivo JWT.
 */
export async function exchangeFirebaseToken(
  firebaseIdToken: string,
  config: TokenExchangeConfig,
): Promise<TokenExchangeResponse> {
  const baseUrl = config.exchangeUrl.replace(/\/+$/, '');
  const response = await axios.post<TokenExchangeResponse>(`${baseUrl}/exchange`, undefined, {
    headers: {
      Authorization: `Bearer ${firebaseIdToken}`,
    },
    timeout: 10_000,
  });
  return response.data;
}

/**
 * Refresh an expired Hetivo JWT using a stateless refresh token.
 * Calls POST /refresh with the expired Bearer token and the refresh token in the body.
 */
export async function refreshHetivoToken(
  expiredToken: string,
  refreshToken: string,
  config: TokenExchangeConfig,
): Promise<TokenExchangeResponse> {
  const baseUrl = config.exchangeUrl.replace(/\/+$/, '');
  const response = await axios.post<TokenExchangeResponse>(
    `${baseUrl}/refresh`,
    { refreshToken },
    {
      headers: { Authorization: `Bearer ${expiredToken}` },
      timeout: 10_000,
    },
  );
  return response.data;
}
